export const PROFILE = {
  codename: 'AGENT SHAH',
  realName: 'Shah Fahad',
  title: 'Software Engineer',
  location: 'Karachi, Pakistan',
  experience: '6+ years',
  tagline: 'Building experiences that scale',
  bio: 'Field-tested software engineer with 6+ years crafting high-performance, real-time web and mobile experiences. Specializes in React, Next.js, Flutter, and real-time communication systems.',
  stats: { projects: 9, companies: 4, clients: 25 },
  contact: {
    email: 'fahaddoc600@gmail.com',
    phone: '+92 304 2186009',
    linkedin: 'linkedin.com/in/fahaddoc600',
    github: 'github.com/fahaddoc'
  }
}

export const SKILLS = {
  Frontend: ['React.js', 'Next.js', 'TypeScript', 'JavaScript', 'Tailwind CSS', 'Redux'],
  Mobile: ['Flutter', 'Dart'],
  Realtime: ['WebRTC', 'SignalR', 'WebSocket'],
  Backend: ['Node.js', 'PHP'],
  Databases: ['MySQL', 'PostgreSQL', 'MongoDB', 'SQLite'],
  Tools: ['Git', 'Vercel', 'Figma', 'Electron']
}

export const PROJECTS = [
  { name: 'Konnect.im', type: 'Video Conferencing', tech: ['React', 'Redux', 'WebRTC', 'SignalR'], desc: 'Multi-participant video conferencing with screen sharing and real-time chat.' },
  { name: 'WhatsApp ChatBot Simulator', type: 'Dev Tool', tech: ['React', 'Redux', 'Tailwind', 'Node'], desc: 'Drag-and-drop visual builder to design and test WhatsApp chatbot flows.' },
  { name: 'Helpers', type: 'Service Booking App', tech: ['Flutter', 'Firebase', 'Google Maps'], desc: 'Live tracking and payment integration platform.' },
  { name: 'KistPay Admin Portal', type: 'Dashboard', tech: ['React', 'Redux', 'Chart.js'], desc: 'Administrative interface and management system with rich visualizations.' },
  { name: 'Reap Agro', type: 'Loan Management', tech: ['React', 'Node', 'PostgreSQL'], desc: 'Agricultural financing platform.' },
  { name: 'Digital Display Manager', type: 'Desktop App', tech: ['React', 'Electron', 'Node'], desc: 'Display content management system.' },
  { name: 'Khawateen Rozgar (EXACT)', type: 'Marketplace', tech: ['React', 'Node', 'MongoDB'], desc: 'Service booking and marketplace platform.' },
  { name: 'KHADIM-E-INSANIYAT OPD', type: 'Healthcare', tech: ['Flutter', 'Floor ORM', 'SQLite'], desc: 'Patient records system for healthcare facility.' },
  { name: 'Civil Hospital Leave Mgmt', type: 'Enterprise', tech: ['jQuery', 'PHP', 'MySQL'], desc: 'Employee leave/absence management system for Dr. Ruth K.M. Pfau Civil Hospital.' }
]

export const EXPERIENCE = [
  { company: 'DigitalHire', role: 'Software Engineer', period: '2023 — Present', notes: 'Leading frontend for hiring platform. Component libraries, multi-step flows, performance.' },
  { company: 'MILETAP / E-OCEAN', role: 'Senior Frontend Developer', period: '2020 — 2024', notes: 'Built Konnect.im video platform and WhatsApp ChatBot Simulator.' },
  { company: 'Freelance', role: 'Full-Stack Developer', period: '2018 — 2020', notes: 'Delivered 10+ apps across Pakistan. Flutter + PHP/MySQL.' },
  { company: 'Junior Dev', role: 'Junior Developer', period: '2016 — 2018', notes: 'Mastered JS, React, web fundamentals. Internal business tools.' }
]

export const SECTORS = [
  { id: 1, name: 'BRIEFING ROOM',    weapon: 'PISTOL', section: 'intro' },
  { id: 2, name: 'DOSSIER',          weapon: 'PISTOL', section: 'about' },
  { id: 3, name: 'ARSENAL',          weapon: 'SWORD',  section: 'skills' },
  { id: 4, name: 'MISSION ARCHIVES', weapon: 'SWORD',  section: 'projects' },
  { id: 5, name: 'FIELD HISTORY',    weapon: 'PENCIL', section: 'experience' },
  { id: 6, name: 'EXTRACTION POINT', weapon: 'PENCIL', section: 'contact' }
]
